import { render } from "./JobDetails.vue?vue&type=template&id=ef779fc0"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\khurr\\OneDrive\\desktop\\development\\refinedhealthpros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__